import {mix} from "@spa/utils/assetPathResolver";
import {useEffect} from "react";
import {initPreviewSize} from "@design/pc/modules/previewSize";
import {trackJobDetailError} from "@spa/features/search_job/pc/api/analytics/trackPage";

const JobDetailError = ({title, translations}) => {
    useEffect(() => {
        // design entry
        initPreviewSize();

        // エラー画面のPV計測
        trackJobDetailError();
    }, []);

    return (
        <>
            <aside className="p-preview_wrap l-c-right u-mt10 s-previewInner s-help_lock">

                <div className="p-preview_content s-preview_content u-mt20" tabIndex="0" aria-label={translations.job_details}>

                    <div className="p-preview_head s-preview_head">
                        <button className="p-preview_focus_btn s-preview_focus_btn" type="button">
                            {translations.return_to_search_results}
                        </button>
                        { title && (<p className="p-detail_head_title p-detail_head_title--preview">{title}</p>)}
                    </div>

                    <div className="p-preview_body s-preview_body">

                        <div className="p-preview_content_inner p-preview_content_inner--full">
                            <div className="p-detail_lines_wrap">
                                <img src={mix("webfront/images/spa/no_data_error.svg")} alt="" width="150" height="150"
                                     loading="lazy"/>
                                <p className="p-detail_lines u-ta_c">{translations.uh_oh_the_job_you}<br/>
                                    {translations.there_may_have_been_an}</p>
                                <p className="p-detail_lines u-ta_c">{translations.in_the_meantime_check_out}</p>
                            </div>
                            <button className="p-preview_focus_btn s-preview_focus_btn">{translations.return_to_search_results}</button>
                        </div>
                    </div>

                </div>

            </aside>
        </>
    )
}

export default JobDetailError;
